module.exports = __webpack_public_path__ + "static/avadhani-28e1d3e7f8420ace21fadf3b0fc97683.jpg";